module.exports = __webpack_public_path__ + "media/newstyle/images/facebook2-cf06f97e1b32e191eb017f8f83f7bc8f.png";